import { ElementsButton, ElementsButtonProps, IconName } from '../../UI';
import { ComponentPropsWithoutRef } from 'react';
import { useCreateFile, UseCreateFileArgs } from '../hooks';
import { MDTailwindMinPixelBreakpointWidth } from '../../util/theme.util';
import { useWindowSize } from 'react-use';

interface CreateFileProps
  extends Pick<ComponentPropsWithoutRef<'div'>, 'className'>,
    Pick<ElementsButtonProps, 'theme' | 'label' | 'size'>,
    UseCreateFileArgs {
  iconName?: IconName;
}

export const CreateFileV2 = ({
  label,
  itemID,
  tenantID,
  standalone,
  className,
  onFileCreation,
  onFileAttachmentCreation,
  size = 'large',
  iconName = 'addCircle',
  theme = 'text',
}: CreateFileProps) => {
  const { loading, fileSelectorRef, onSelectFile } = useCreateFile({
    itemID,
    tenantID,
    standalone,
    onFileCreation,
    onFileAttachmentCreation,
  });
  const { width: windowWidth } = useWindowSize();
  return (
    <>
      <ElementsButton
        label={label}
        theme={theme}
        size={size}
        type="button"
        className={className}
        icon={loading ? 'spinner' : iconName}
        onClick={() => !loading && fileSelectorRef.current?.click()}
        iconPosition={windowWidth < MDTailwindMinPixelBreakpointWidth ? 'right' : 'left'}
      />
      <input hidden type="file" id="logoFile" ref={fileSelectorRef} onChange={onSelectFile} />
    </>
  );
};
